<template>
  <div class="app-shell">
    <!-- 全局背景（渐变 + 轻纹理） -->
    <div class="app-bg" aria-hidden="true"></div>

    <!-- 顶部导航 -->
    <NavBar />

    <!-- 内容区域：只负责宽度与留白，不再画“外层卡片” -->
    <main class="app-main">
      <div class="app-container">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </main>

    <div class="app-footer-space"></div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  name: "App",
  components: { NavBar },
};
</script>

<style scoped>
.app-shell {
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

/* ✅ 更“大”的背景：保持你现在这套就很好 */
.app-bg {
  position: fixed;
  inset: 0;
  z-index: -1;
  background:
    radial-gradient(1100px 620px at 16% 10%, rgba(13,110,253,0.14), transparent 62%),
    radial-gradient(980px 620px at 86% 18%, rgba(102,16,242,0.12), transparent 58%),
    linear-gradient(180deg, #f7f9fc 0%, #f3f6fb 40%, #f7f9fc 100%);
}

.app-bg::after {
  content: "";
  position: absolute;
  inset: 0;
  opacity: 0.32;
  background-image:
    linear-gradient(rgba(15,23,42,0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(15,23,42,0.06) 1px, transparent 1px);
  background-size: 34px 34px;
  mask-image: radial-gradient(circle at 50% 18%, rgba(0,0,0,1), rgba(0,0,0,0.35) 58%, rgba(0,0,0,0));
}

.app-main {
  padding: 18px 16px 28px;
}

/* ✅ 只做布局：宽度 + 居中 + 轻留白（不画边框/阴影/白底） */
.app-container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0; /* 让每个页面自己决定“画布/卡片” */
}

@media (max-width: 640px) {
  .app-main {
    padding: 12px 12px 20px;
  }
}

.app-footer-space {
  height: 24px;
}
</style>

